<template>
  <div class="selectEngineerList">
    <el-table
      ref="multipleTable"
      :data="engineerItems"
      border
      stripe
      style="width: 100%; margin-top: 20px"
      height="calc(100vh - 180px)"
      width="100%"
      :summary-method="getSummaries"
      show-summary
    >
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column
        v-for="(item, index) in tableColumnDatas"
        :key="index"
        :prop="item.class"
        :label="item.labelName"
        :sortable="item.sortEnable"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="item.showable">{{
            scope.row[scope.column.property] | numFilter
          }}</span>
          <span v-else-if="item.isNumFilter">{{
            scope.row[scope.column.property] | numFilter
          }}</span>

          <span v-else>{{ scope.row[scope.column.property] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { numFilter } from "@/utils/filters";
export default {
  name: "selectEngineerList",
  props: {
    engineerItems: {
      type: Array,
    },
    contractType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tableColumnDatas: [
        { class: "subCategoryNo", labelName: "细目号", sortEnable: false },
        { class: "subCategoryName", labelName: "细目名称", sortEnable: false },
        { class: "typeShow", labelName: "类型", sortEnable: false },
        {
          class: "materialCoefficient",
          labelName: "材料系数",
          sortEnable: false,
        },
        { class: "calculateFormula", labelName: "计算公式", sortEnable: false },

        { class: "unit", labelName: "单位", sortEnable: false },
        { class: "quantity", labelName: "数量", sortEnable: false },
        {
          class: "materialPrice",
          labelName: "材料单价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "totalPrice",
          labelName: "金额",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "guideLaborPrice",
          labelName: "指导劳务单价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "bidPrice",
          labelName: "中标裸税单价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "taxRate",
          labelName: "税率",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "synthesizePriceAfterTax",
          labelName: "税后综合单价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "totalPurePrice",
          labelName: "裸税合价",
          sortEnable: false,
          isNumFilter: false,
        },
        {
          class: "totalPriceAfterTax",
          labelName: "税后合价",
          sortEnable: false,
          isNumFilter: false,
        },
        { class: "remarks", labelName: "备注", sortEnable: false },
      ],
      labeltableColumnDatas: [
        { class: "subCategoryNo", labelName: "细目号", sortEnable: false },
        { class: "subCategoryName", labelName: "细目名称", sortEnable: false },
        { class: "typeShow", labelName: "类型", sortEnable: false },
        {
          class: "materialCoefficient",
          labelName: "材料系数",
          sortEnable: false,
        },
        { class: "calculateFormula", labelName: "计算公式", sortEnable: false },

        { class: "unit", labelName: "单位", sortEnable: false },
        { class: "quantity", labelName: "数量", sortEnable: false },
        {
          class: "materialPrice",
          labelName: "材料单价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "totalPrice",
          labelName: "金额",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "guideLaborPrice",
          labelName: "指导劳务单价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "bidPrice",
          labelName: "中标裸税单价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "taxRate",
          labelName: "税率",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "synthesizePriceAfterTax",
          labelName: "税后综合单价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "totalPurePrice",
          labelName: "裸税合价",
          sortEnable: false,
          isNumFilter: false,
        },
        {
          class: "totalPriceAfterTax",
          labelName: "税后合价",
          sortEnable: false,
          isNumFilter: false,
        },
         { class: "model", labelName: "规格型号", sortEnable: false },
        { class: "factoryName", labelName: "厂商", sortEnable: false },
        { class: "remarks", labelName: "备注", sortEnable: false },
      ],
      othertableColumnDatas: [
        { class: "subCategoryNo", labelName: "细目号", sortEnable: false },
        { class: "subCategoryName", labelName: "细目名称", sortEnable: false },
        { class: "typeShow", labelName: "类型", sortEnable: false },
        {
          class: "materialCoefficient",
          labelName: "材料系数",
          sortEnable: false,
        },
        { class: "calculateFormula", labelName: "计算公式", sortEnable: false },

        { class: "unit", labelName: "单位", sortEnable: false },
        { class: "quantity", labelName: "数量", sortEnable: false },
        {
          class: "materialPrice",
          labelName: "材料单价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "totalPrice",
          labelName: "金额",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "bidPrice",
          labelName: "中标裸税单价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "taxRate",
          labelName: "税率",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "totalPurePrice",
          labelName: "裸税合价",
          sortEnable: false,
          isNumFilter: false,
        },
        {
          class: "totalPriceAfterTax",
          labelName: "税后合价",
          sortEnable: false,
          isNumFilter: false,
        },
        { class: "remarks", labelName: "备注", sortEnable: false },
      ],
    };
  },
  mounted() {
    if (this.contractType === "LABOR") {
      this.tableColumnDatas = this.labeltableColumnDatas;
    } else {
      this.tableColumnDatas = this.othertableColumnDatas;
    }
  },
  watch: {
    contractType(newVal) {
      if (newVal === "LABOR") {
        this.tableColumnDatas = this.labeltableColumnDatas;
      } else {
        this.tableColumnDatas = this.othertableColumnDatas;
      }
    },
  },
  methods: {
    getSummaries(param) {
      let _this = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 6) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (
          !values.every((value) => isNaN(value)) &&
          (column.property == "quantity" ||
            column.property == "totalPrice" ||
            column.property == "totalPurePrice" ||
            column.property == "totalPriceAfterTax")
        ) {
          sums[index] = values.reduce((prev, curr) => {
            // curr.replace(/,/g, "")
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          // sums[index] += '';
          // this.$set();
          
            sums[index] = numFilter(sums[index]);
         
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.selectEngineerList {
  overflow: auto;
  // /deep/.el-table__body-wrapper {
  //   height: auto !important;
  // }
}
</style>
